import { render, staticRenderFns } from "./InsuranceRiskPaymentTableList.vue?vue&type=template&id=3fd98faf&scoped=true&"
import script from "./InsuranceRiskPaymentTableList.vue?vue&type=script&lang=js&"
export * from "./InsuranceRiskPaymentTableList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRiskPaymentTableList.vue?vue&type=style&index=0&id=3fd98faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd98faf",
  null
  
)

export default component.exports